import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';

// Service
import { LimitFlowProposalService } from '../../../service/limit-flow-proposal/limit-flow-proposal.service';
import { CommonService } from '../../../../common/service/common.service';

@Component({
	moduleId: module.id,
	selector: 'other-revenues',
	templateUrl: 'other-revenue.component.html',
	providers: [
		CommonService
	]
})
export class OtherRevenueComponent implements OnInit {

	@Input('proposalID') proposalID: string = "";	
	@Input('isProposalRevenue') isProposalRevenue: string = "";
	@Input('proposalRevenueDocument') proposalRevenueDocument: string = "";
	@Input('currentTab') currentTab: string = "";
	@Input('proposalStatus') proposalStatus: string = "";
	@Input('isUserOwner') isUserOwner: boolean = false;

	private token;
	public revenues: any[] = [];
	public editOtherRevenueIndex: number = undefined;
	otherRevenue: FormGroup;

	constructor(private fb: FormBuilder, private flashMessagesService: FlashMessagesService, private limitFlowProposalService: LimitFlowProposalService, private commonService: CommonService) {
		this.otherRevenue = fb.group({
			ID: '',
			ReceitaID: ['', Validators.compose([Validators.required])],
			AnoOutrasReceitas: ['', Validators.compose([Validators.required])],
			ReceitaPrevista: ['', Validators.compose([Validators.required])]
		});
	}

	ngOnInit() {
		this.token = localStorage.getItem('yara.token');
		$("#totalOutrasReceitas").val(this.getOtherRevenueTotal());
		this.getRevenue();
	}

	maxLengthCheck(e) {
		if (e.target.value.length > e.target.maxLength) {
			e.target.value = e.target.value.slice(0, e.target.maxLength)
		}
	}

	saveProposalRevenue(revenue) {
		revenue.Documento = this.proposalRevenueDocument;
		this.limitFlowProposalService.otherRevenueObj.push(revenue);
		$("#totalOutrasReceitas").val(this.getOtherRevenueTotal());
		this.flashMessagesService.show("Outra receita adicionada", { cssClass: 'alert-success', timeout: 6000 });
		this.otherRevenue.reset();
	}

	deleteProposalRevenue(index) {
		this.limitFlowProposalService.otherRevenueObj.splice(index, 1);
		$("#totalOutrasReceitas").val(this.getOtherRevenueTotal());
		this.flashMessagesService.show("Outra receita removida", { cssClass: 'alert-success', timeout: 6000 });
	}

	getProposalRevenues() {
		if (this.proposalID) {
			this.limitFlowProposalService.getProposalRevenues(this.token, this.proposalID).subscribe(result => {
				if (result.Success) {
					this.limitFlowProposalService.otherRevenueObj = result.Result;
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);
				
			});
		}
	}

	getRevenue() {
		if (this.revenues.length === 0) {
			this.limitFlowProposalService.getReveneu(this.token).subscribe(result => {
				if (result.Success) {
					this.revenues = result.Result;
					//this.getProposalRevenues();
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);
				
			});
		}
	}

	getOtherRevenueTotal() {
		let sum = 0;

		for (let i = 0; i < this.limitFlowProposalService.otherRevenueObj.length; i++) {
			if (this.isProposalRevenue && this.limitFlowProposalService.otherRevenueObj[i].Documento === this.proposalRevenueDocument) {
				sum += this.limitFlowProposalService.otherRevenueObj[i].ReceitaPrevista;
			} else if (!this.isProposalRevenue && !this.limitFlowProposalService.otherRevenueObj[i].Documento) {
				sum += this.limitFlowProposalService.otherRevenueObj[i].ReceitaPrevista;
			}
		}

		return sum;
	}

	getDescricao(ReceitaID) {
		var desc; 
		var item = this.revenues.filter(item => item.ID === ReceitaID);
		desc = item[0] ? item[0].Descricao : "";
		return desc; 
	}

	editOtherRevenue(index) {
		this.editOtherRevenueIndex = index;
		this.otherRevenue.patchValue({
			ReceitaID: this.limitFlowProposalService.otherRevenueObj[index].ReceitaID,
			AnoOutrasReceitas: this.limitFlowProposalService.otherRevenueObj[index].AnoOutrasReceitas,
			ReceitaPrevista: this.limitFlowProposalService.otherRevenueObj[index].ReceitaPrevista
		});
		($(".other-list table tbody tr")as any).eq(index).addClass("edit-line");
		($(".other-form")as any).addClass("editing");
	}

	saveOtherRevenueEdit(index) {
		this.limitFlowProposalService.otherRevenueObj[this.editOtherRevenueIndex].ReceitaID = this.otherRevenue.controls['ReceitaID'].value;
		this.limitFlowProposalService.otherRevenueObj[this.editOtherRevenueIndex].AnoOutrasReceitas = this.otherRevenue.controls['AnoOutrasReceitas'].value;
		this.limitFlowProposalService.otherRevenueObj[this.editOtherRevenueIndex].ReceitaPrevista = this.otherRevenue.controls['ReceitaPrevista'].value;
		this.editOtherRevenueIndex = undefined;
		this.otherRevenue.reset();
		($(".other-list table tbody tr") as any).removeClass("edit-line");
		($(".other-form")as any).removeClass("editing");
		$("#totalOutrasReceitas").val(this.getOtherRevenueTotal());
	}

	cancelOtherRevenueEdit() {
		this.editOtherRevenueIndex = undefined;
		($(".other-list table tbody tr") as any).removeClass("edit-line");
		($(".other-form")as any).removeClass("editing");
		this.otherRevenue.reset();
	}

}






// WEBPACK FOOTER //
// ./src/app/limit-flow-proposal/component/limit-flow-proposal/other-revenue/other-revenue.component.ts